module.exports = __webpack_public_path__ + "img/data_process_monochromatic.4e371683.svg";